import { Introduction } from '@components/introduction';
import { useFragment } from 'react-relay';
import { subscriptionIntroductionFragment } from './SubscriptionIntroduction.relay';
import type { SubscriptionIntroductionPropsType } from './types';

const SubscriptionIntroduction: React.FC<SubscriptionIntroductionPropsType> = (props: SubscriptionIntroductionPropsType) => {
  const component = useFragment(subscriptionIntroductionFragment, props.component);

  return <Introduction component={component} forceLongText={true} />;
};

export { SubscriptionIntroduction };
